import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../_constants/validation-format-constants';
import { VendorContractDocumentRawDto } from '../../../shared-ciramail-module/_models/vendor-contract-document-raw-dto';

export class VendorContractRawDto {
    contractId: number;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    effectiveDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    endDate: Date;
    contractTypeCode: string;
    contractTermCode: string;
    autoRenewalFrequencyCode: string;
    autoRenewalPeriod: number;
    serviceFrequencyCode: string;
    serviceCategoryCode: string;
    serviceDescription: string;

    @Type(() => VendorContractDocumentRawDto)
    documents: VendorContractDocumentRawDto[];

    communityVendorId: number;
    vendorCode: string;
    communityId: number;
    clearCache: boolean;
}
